import React from 'react';
import { ButtonApp } from 'src/components/ApartmentPageV2/Button';
import { ReactComponent as LinkedDealIcon } from 'src/assets/icon_apartment_linked_deal.svg';
import { useStyles } from 'src/components/ApartmentConnectDeal/components/Buttons/LinkedToDealButton/styles';

export const LinkedToDealButton: React.FC = () => {
  const styles = useStyles();
  return (
    <ButtonApp
      startIcon={<LinkedDealIcon />}
      customClassName={styles.button}
      fullWidth
      text="Linked to current deal"
      variant="contained"
      disabled
    />
  );
};
